import {Directive} from '@angular/core';

@Directive({
  selector: 'input[msTextInput][type=text]',
  exportAs: 'msTextInput',
  standalone: true,
})
export class TextInputDirective {}
